import {Injectable} from '@angular/core';
import {IRouteState, Presenter} from "../presenter/presenter";
import {NavigationCancel, NavigationEnd, NavigationStart, RouteConfigLoadEnd, Router} from "@angular/router";
import {emptyResourceGroup, IResource, IResourceGroup} from "@retail-data-factory/rdf-angular-types-api";
import {SetCurrentResource, UpdateResource} from "../../../store/app-store/actions/resources/resources.actions";
import {logger} from "@retail-data-factory/rdf-angular-utils";
import {AssistTranslationService} from "@retail-data-factory/rdf-angular-translation-service";
import {IListItem} from "@retail-data-factory/rdf-angular-types-components";

@Injectable({
  providedIn: 'root'
})
export class RdfRouterService {
  lastResource: IResource = null;
  routeHistory: Array<IRouteState> = [];

  constructor(
    private presenter: Presenter,
    private assistTranslationService: AssistTranslationService,
    private router: Router
  ) {
    console.log('RdfRouterService Init');
    this.router.events.subscribe(value => {

      if (value instanceof RouteConfigLoadEnd) {
        setTimeout(() => {
          const abc = value;
          const config = this.router.config;
          console.log('dddd');

        });

      }

      if (value instanceof NavigationStart) {
        this.pushRoute({id: value.id, url: value.url, urlAfterRedirects: '', status: "started"});
      }
      if (value instanceof NavigationCancel) {
        this.pushRoute({id: value.id, url: value.url, urlAfterRedirects: '', status: "canceled"});
      }

      if (value instanceof NavigationEnd) {
        this.pushRoute({id: value.id, url: value.url, urlAfterRedirects: value.urlAfterRedirects, status: "finished"});
      }
      console.log(value);
      if (!this.presenter.resourcesState.isLoaded) {
        return;
      }
      const tmp = this.presenter.resourcesState;
      const url = decodeURIComponent(value['url']);
      let newResource = this.presenter.resourcesState.data.resources.find(res => url === `${res.url ? res.url : ''}${res.profile && res.profile['url'] ? res.profile['url'] : ''}` && res.type === 'SCREEN');
      if (!newResource) {
        //По полной ссылке не нашли. Пытаемся найти первый попавшийся ресурс по url группы
        newResource = this.presenter.resourcesState.data.resources.find(res => url === `${res.url ? res.url : ''}` && res.type === 'SCREEN');
      }
      if (newResource)
        this.setCurrentResource(newResource);
    });


  }


  /**
   * Получить список ресурсов по коду группы
   * @param groupCode
   */
  filterResourceByGroup(groupCode: string): Array<IResource> {
    let result: Array<IResource> = [];
    if (this.presenter.resourcesState) {
      if (this.presenter.resourcesState.isLoaded) {
        result = this.presenter.resourcesState.data.resources.filter(res => res.groupCode === groupCode);
      }
    }
    return result;
  }

  /**
   * Получить список ресурсов по типу, и если необходимо, группе
   * @param resourceType
   * @param groupCode
   */
  filterResourceByType(resourceType: string, groupCode?: string): Array<IResource> {
    let result: Array<IResource> = [];
    if (this.presenter.resourcesState) {
      if (this.presenter.resourcesState.isLoaded) {
        if (!groupCode) {
          //Код группы не передали, фильтруем без него
          result = this.presenter.resourcesState.data.resources.filter(res => res.type === resourceType);
        } else {
          //Код группы передали, фильтруем с ним
          result = this.presenter.resourcesState.data.resources.filter(res => res.groupCode === groupCode && res.type === resourceType);
        }
      }
    }
    return result;
  }

  /**
   * Проверить, доступен ли ресурс пользователю
   * @param resourceCode
   */
  isResourceAvailable(resourceCode: string): boolean {
    return this.presenter.resourcesState.data.resources.findIndex(item => item.code === resourceCode) !== -1;
  }

  /**
   * Получить ресурс по коду
   * @param resourceCode
   */
  getResource(resourceCode: string): IResource {
    return this.presenter.resourcesState.data.resources.find(item => item.code === resourceCode);
  }

  /**
   * Получить тип report_type ресурса.
   * Если report_type у данного ресурса отсутствует - возвращается пустая строка
   * @param resourceCode
   */
  getResourceReportType(resourceCode: string): string {

    const resource = this.getResource(resourceCode);
    if (resource && resource.profile && resource.profile['report_type']) {
      return resource.profile['report_type'];
    } else {
      return '';
    }
  }


  getResourceUrl(resourceCode: string): string {

    const resource = this.getResource(resourceCode);
    if (resource && resource.profile && resource.profile['url']) {
      return resource.profile['url'];
    } else {
      return '';
    }
  }

  getCurrentResourceFullUrl(): string {
    const url = this.getCurrentApplication().url + this.getResourceUrl(this.getCurrentResource().code);
    return url;

  }

  /**
   * Получить ресурс по ID
   */
  getResourceById(id: string): IResource {
    return this.presenter.resourcesState.data.resources.find(item => item.id === id);
  }

  /**
   * Получить ресурс по url
   * @param url
   */
  getResourceByUrl(url: string): IResource {
    console.log(`getResourceByUrl url = ${url}`);
    return this.presenter.resourcesState.data.resources.find(item => item.url === url);
  }


  /**
   * Получить ресурс по url
   * @param url
   */
  getResourceByFullUrl(url: string): IResource {
    console.log(`getResourceByUrl url = ${url}`);
    return this.presenter.resourcesState.data.resources.find(item => item.profile && item.profile['url'] ? `${item.url}${item.profile['url']}` === url : item.url === url);
  }

  updateResource(resource: IResource) {
    this.presenter._store.dispatch(new UpdateResource(resource));
  }

  /**
   * получить группу ресурсов по url ресурса
   * @param url
   */
  getResourceGroupByResourceUrl(url: string): IResourceGroup {
    if (!url) {
      return undefined;
    }
    let tmpUrl = url;
    if (tmpUrl.charAt(tmpUrl.length - 1) !== '/') {
      tmpUrl = tmpUrl + '/';
    }
    const resourceGroup: IResourceGroup = this.presenter.resourcesState.data.resourceGroups.find(item => {
      let groupUrl = item.url;
      if (!groupUrl) {
        return false;
      }
      if (groupUrl.charAt(groupUrl.length - 1) !== '/') {
        groupUrl = groupUrl + '/';
      }
      if (tmpUrl.indexOf(groupUrl) === 0) {
        return true;
      }
      return false
    });
    return resourceGroup;
  }

  getResourceGroupFromResource(resource: IResource): IResourceGroup {
    const result: IResourceGroup = {
      ...emptyResourceGroup,
      id: resource.groupId,
      name: resource.groupName,
      description: resource.groupDescription,
      code: resource.groupCode,
      profile: resource.resourceGroupProfile
    };
    return result;
  }

  getResourceGroup(groupCode: string): IResourceGroup {
    return this.presenter.resourcesState.data.resourceGroups.find(t => t.code === groupCode);
  }


  /**
   * Получить список ресурсов
   */
  getResources(): Array<IResource> {
    return this.presenter.resourcesState.data.resources;
  }

  /**
   * Получить список групп ресурсов, который включает в себя список ресурсов в каждой группе
   */
  getResourceGroups(): Array<IResourceGroup> {
    return this.presenter.resourcesState.data.resourceGroups;
  }

  /**
   * Получить текущий ресурс
   */
  getCurrentResource(): IResource {
    return this.presenter.getCurrentStateValue(this.presenter.currentResource$);
  }

  getCurrentApplication(): IResourceGroup {
    //Сначала пытаемся получить application на основании url
    const currentRoute = this.router.url;
    const appFromUrl: IResourceGroup = this.getResourceGroupByResourceUrl(currentRoute);
    if (appFromUrl) {
      return appFromUrl;
    }
    //Иначе получаем application cтандартным способом через текущий ресурс
    const currentResource = this.getCurrentResource();
    if (currentResource && currentResource.code) {
      const app: IResourceGroup = this.presenter.resourcesState.data.resourceGroups.find(t => t.id === currentResource.groupId);
      if (app) {
        return app;
      } else {
        return {...emptyResourceGroup};
      }
    } else {
      return {...emptyResourceGroup};
    }
  }

  getCurrentScreens(): Array<IResource> {
    const application: IResourceGroup = this.getCurrentApplication();
    return application ? application.resources.filter(t => t.type === 'SCREEN') : [];
  }

  // getResources(): IResourcesState {
  //   return this.getCurrentStateValue(this.resources$);
  // }


  createApplicationsArrayFromResources(resources: Array<IResource>): Array<IResourceGroup> {
    const result: Array<IResourceGroup> = [];
    resources.forEach(res => {
      const app: IResourceGroup = result.find(t => t.id === res.groupId);
      if (app) {
        app.resources.push(res);
      } else {
        result.push(
          {
            ...emptyResourceGroup,
            id: res.groupId,
            code: res.groupCode,
            name: res.groupName,
            description: '',
            img: '',
            url: res.url,
            profile: null,
            resources: [res]
          }
        );
      }
    });

    return result;
  }


  /**
   * Получение локализации названия ресурса по его коду
   * @param resourceCode
   * @param lang
   */
  getTranslatedResourceName(resourceCode: string, lang?: string): string {
    const resource: IResource = this.getResource(resourceCode);
    if (!resource) {
      return '';
    }
    const result = this.getTranslatedResourceInfo(resource, 'name', lang);
    return result;
  }

  /**
   * Получение локализации короткого названия ресурса по его коду
   * @param resourceCode
   * @param lang
   */
  getTranslatedResourceShortName(resourceCode: string, lang?: string): string {
    const resource: IResource = this.getResource(resourceCode);
    if (!resource) {
      return '';
    }
    const result = this.getTranslatedResourceInfo(resource, 'shortname', lang);
    return result;
  }

  getTranslatedResourceDescription(resourceCode: string, lang?: string): string {
    const resource: IResource = this.getResource(resourceCode);
    if (!resource) {
      return '';
    }
    const result = this.getTranslatedResourceInfo(resource, 'description', lang);
    return result;
  }

  /**
   * Получение локализации ресурса по ресурсу и типу локализации
   * @param resource Ресурс
   * @param paramName - что переводим - name, shortname, description
   * @param lang - язык, не обязательно. Если не указан - то берется текущий
   */
  getTranslatedResourceInfo(resource: IResource, paramName: 'name' | 'shortname' | 'description', lang?: string): string {
    if (!lang) {
      lang = this.assistTranslationService.getCurrentLang();
    }
    let result = '';

    if (!resource) return '';
    //алгоритм:
    //тест по умолчанию из профиля -> текст переведенный текст из профиля -> перевод из локализации i18n ( но только в том случае если перед этим был null

    //сначала текст по умолчанию
    result = resource && resource.profile && resource.profile['default_name'] && resource.profile['default_name'][paramName] ? resource.profile['default_name'][paramName] : '';

    //теперь перевод из профиля
    result = resource && resource.profile && resource.profile['translation'] && resource.profile['translation'][lang] && resource.profile['translation'][lang][paramName] ? resource.profile['translation'][lang][paramName] : result;

    if (!result) {
      const i18nResult = this.assistTranslationService.instant(`reports.${resource.groupCode}.reports.${resource.code}.${paramName}`);
      if (i18nResult !== `reports.${resource.groupCode}.reports.${resource.code}.${paramName}`) {
        return i18nResult;
      } else {
        switch (paramName) {
          case "name":
            return resource.name;
          case "shortname":
            return resource.name;
          case "description":
            return resource.description;
          default:
            return resource.name;
        }

      }
    } else {
      return result;
    }
  }

  getTranslatedResourceGroupName(groupCode: string, lang?: string): string {
    const resourceGroup: IResourceGroup = this.getResourceGroup(groupCode);
    if (!resourceGroup) {
      return '';
    }
    const result = this.getTranslatedResourceGroupInfo(resourceGroup, 'name', lang);
    return result;
  }

  getTranslatedResourceGroupShortName(groupCode: string, lang?: string): string {
    const resourceGroup: IResourceGroup = this.getResourceGroup(groupCode);
    if (!resourceGroup) {
      return '';
    }
    const result = this.getTranslatedResourceGroupInfo(resourceGroup, 'shortname', lang);
    return result;
  }

  getTranslatedResourceGroupDescritption(groupCode: string, lang?: string): string {
    const resourceGroup: IResourceGroup = this.getResourceGroup(groupCode);
    if (!resourceGroup) {
      return '';
    }
    const result = this.getTranslatedResourceGroupInfo(resourceGroup, 'description', lang);
    return result;
  }

  getTranslatedResourceGroupInfo(resourceGroup: IResourceGroup, paramName: 'name' | 'shortname' | 'description' | 'long-description', lang?: string): string {
    if (!lang) {
      lang = this.assistTranslationService.getCurrentLang();
    }
    let result = '';

    //алгоритм:
    //тест по умолчанию из профиля -> текст переведенный текст из профиля -> перевод из локализации i18n ( но только в том случае если перед этим был null

    //сначала текст по умолчанию
    result = resourceGroup.profile && resourceGroup.profile['default_name'] && resourceGroup.profile['default_name'][paramName] ? resourceGroup.profile['default_name'][paramName] : '';

    //теперь перевод из профиля
    result = resourceGroup.profile && resourceGroup.profile['translation'] && resourceGroup.profile['translation'][lang] && resourceGroup.profile['translation'][lang][paramName] ? resourceGroup.profile['translation'][lang][paramName] : result;

    if (!result) {
      if (paramName === 'description') paramName = 'long-description';
      const i18nResult = this.assistTranslationService.instant(`reports.${resourceGroup.code}.${paramName}`);
      if (i18nResult !== `reports.${resourceGroup.code}.${paramName}`) {
        return i18nResult;
      } else {
        return '';
      }
    } else {
      return result;
    }
  }

  pushRoute(route: IRouteState) {
    const f = this.routeHistory.find(t => t.id === route.id);
    if (f) {
      f.status = route.status;
      f.url = route.url;
      f.urlAfterRedirects = f.urlAfterRedirects ? f.urlAfterRedirects : route.urlAfterRedirects;
    } else {
      this.routeHistory.push(route);
    }
  }

  /**
   * Перейти на ресурс
   * @param resource
   * @param forceRoute - безусловный переход. Даже если текущй ресурс и требуемый ресурс совпадают, то все равно перейти
   */
  setCurrentResource(resource: IResource, forceRoute = false) {

    if (!resource) {
      logger.warning('Переход на пустой ресурс. Ничего не делаем');
      return;
    }
    const resourceUrl = resource.profile && resource.profile['url'] ? resource.profile['url'] : '';
    const fullUrl = `${resource.url}${resourceUrl}`;


    //Если делаем смену ресурса на тоже самое - ничего не делаем.
    if (resource && this.lastResource && resource.code === this.lastResource.code && forceRoute === false) {
      logger.warning('Переход на тот же самый ресурс. Ничего не делаем');
      return;
    }
    this.lastResource = resource;
    if (resourceUrl) {
      this.router.navigateByUrl(fullUrl).catch((error) => {
        console.error(error);
      });
    }
    //this._store.dispatch(new SetCurrentResource(resource));


    if (resource) {
      this.presenter._store.dispatch(new SetCurrentResource(resource));
    }

    if ((resource && this.lastResource && this.lastResource.code !== resource.code) || (resource && !this.lastResource)) {
      this.lastResource = resource;
      if (resource.profile && resource.profile['url']) {
        const fullUrl2 = `${resource.url}${resource.profile['url']}`;
        this.router.navigateByUrl(fullUrl2).catch(error => console.error(error));
      }
    }
    this.lastResource = resource;

  }

  convertResourceToListItem(resource: IResource): IListItem {
    const result: IListItem = {
      code: resource.code,
      text: resource?.profile?.default_name?.name ? resource?.profile?.default_name?.name : resource.name,
      item: resource,
      translation: {
        ru: resource?.profile?.translation?.ru?.name,
        en: resource?.profile?.translation?.en?.name,
        ro: resource?.profile?.translation?.ro?.name,
        fr: resource?.profile?.translation?.fr?.name,
        ua: resource?.profile?.translation?.ua?.name,
        de: resource?.profile?.translation?.de?.name,
        es: resource?.profile?.translation?.es?.name
      }
    };
    return result;
  }

}
